import { createReducer, on } from '@ngrx/store';
import { loadSysparamsFailure, loadSysparamsSuccess, setCardIdMaxAttempt, setHomeS4AddChecksum, setMaxNbSendMailMedicalForm, setPrintLightEnabled, setStopProcessInterval, setWebSiteStarted } from './kiosk.actions';


export const kioskFeatureKey = 'kiosk';

export interface KioskState {
  sysParamsLoaded: boolean;
  stopProcessInterval: number;
  cardIdMaxAttempt: number;
  homeS4AddChecksum: boolean;
  printLightEnabled: boolean;
  websiteStarted: boolean;
  maxNbSendMailMedicalForm: number;
}

export const initialState: KioskState = {
  sysParamsLoaded: undefined,
  stopProcessInterval: 120,
  cardIdMaxAttempt: 3,
  homeS4AddChecksum: undefined,
  printLightEnabled: undefined,
  websiteStarted: false,
  maxNbSendMailMedicalForm: 2
};



export const kioskReducer = createReducer(
  initialState,
  on(setWebSiteStarted, (state, { data }) => ({ ...state, websiteStarted: data, })),
  on(loadSysparamsSuccess, (state,) => ({
    ...state,
    sysParamsLoaded: true,
  })),
  on(loadSysparamsFailure, (state,) => ({
    ...state,
    sysParamsLoaded: false,
  })),

  on(setStopProcessInterval, (state, { data }) => ({
    ...state,
    stopProcessInterval: data,
  })),
  on(setCardIdMaxAttempt, (state, { data }) => ({
    ...state,
    cardIdMaxAttempt: data,
  })),
  on(setHomeS4AddChecksum, (state, { data }) => ({
    ...state,
    homeS4AddChecksum: data,
  })),
  on(setPrintLightEnabled, (state, { data }) => ({
    ...state,
    printLightEnabled: data,
  })),
  on(setMaxNbSendMailMedicalForm, (state, { data }) => ({
    ...state,
    maxNbSendMailMedicalForm: data,
  })),
);

